<template>
    <div class="empty" />
</template>

<script>

export default {
  name: 'Empty'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.empty {
    height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/comm/Empty.vue